module.exports = __webpack_public_path__ + "img/118BT.9afc0a05.png";